export default "__VITE_ASSET__C2nNdLVx__"